import PropTypes from 'prop-types';

function MMSnacksActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M4.16719 12.8444L21.778 7.16281C21.3172 2.20682 4.13816 9.9238 3.66651 11.3388C3.60104 11.8816 3.66443 12.4322 3.85154 12.946L4.16719 12.8444Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.88547 10.3956C4.33762 8.17161 5.89771 5.63557 9.29361 8.29497C12.6895 10.9544 9.76527 13.5086 9.76527 13.5086L6.53988 13.4251C6.53988 13.4251 5.08864 11.2337 4.88547 10.3956Z"
                fill="#DFA455"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M6.60158 8.83936C5.08867 7.13415 4.75851 4.33326 9.05055 4.60536C13.3426 4.87747 13.7961 9.74639 13.7961 9.74639L10.1354 11.7418C10.1354 11.7418 7.36349 9.69196 6.60158 8.83936Z"
                fill="#DFA455"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M14.4238 9.88042C12.6098 8.48723 12.247 5.20742 15.8025 3.34983C19.612 1.35438 19.7934 7.80514 19.7934 7.80514L17.8343 10.3448L14.4238 9.88042Z"
                fill="#DFA455"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M12.4683 10.432C11.2166 8.51269 10.9554 4.6669 15.2474 4.939C19.5394 5.21111 18.2406 10.2433 18.2406 10.2433L15.5485 11.9993L12.4683 10.432Z"
                fill="#DFA455"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M7.65015 13.1129C7.10593 10.8852 8.13631 7.17007 12.0946 8.84988C16.0528 10.5297 13.1576 14.8508 13.1576 14.8508L10.0338 15.6127L7.65015 13.1129Z"
                fill="#DFA455"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M14.7286 12.4494C13.4769 10.5301 14.2062 7.312 18.1971 6.73151C22.4528 6.11836 20.5009 12.2607 20.5009 12.2607L17.8089 14.0167L14.7286 12.4494Z"
                fill="#DFA455"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M3.8515 12.9463C4.57759 15.0846 5.86739 16.9874 7.58482 18.4537C10.919 21.3562 9.544 27.9231 11.5757 28.8555C13.6075 29.7879 30.4128 26.5916 27.6047 20.5508C25.3625 15.7182 22.2133 12.1227 21.778 7.16309L3.8515 12.9463Z"
                fill="#395A81"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M3.8515 12.9463L21.778 7.16309C21.8435 7.77281 21.9428 8.37842 22.0755 8.97714L4.40297 14.3286L3.8515 12.9463Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.2992 15.3554C12.3668 16.8683 10.3532 20.9934 14.8484 22.8075C19.3436 24.6215 21.5132 20.9572 21.7418 19.4152C21.9849 17.5794 21.5205 15.3445 19.9278 14.4302C18.335 13.5159 14.638 13.1821 13.2992 15.3554Z"
                fill="#B0C372"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.0133 22.7529L12.2215 27.6545L18.5852 25.913C18.5852 25.913 14.6523 25.5502 13.553 25.1475C13.2119 25.0169 11.0133 22.7529 11.0133 22.7529Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.4418 18.345C14.5253 17.9169 15.1348 15.5332 17.1303 15.9432C19.1257 16.3532 19.7497 17.1949 20.1343 17.9967"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.257 20.1589C14.5835 20.6233 17.5622 23.1412 19.9023 20.0029"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default MMSnacksActive;

MMSnacksActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMSnacksActive.defaultProps = {
    className: null,
};
